// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"605":"96ad9207","878":"11cf78f3"}[chunkId] + ".chunk.css";
};